import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
//import axios from 'axios'
import api from "./services/EventService";
import VTooltip from "v-tooltip";
import VueSweetalert2 from "vue-sweetalert2";
import VueToasted from "vue-toasted";
import VueConfirmDialog from "vue-confirm-dialog";
import loading from "vuejs-loading-screen";
import "animate.css";
import SequentialEntrance from "vue-sequential-entrance";
import "vue-sequential-entrance/vue-sequential-entrance.css";
import i18n from "./i18n/";
import rate from "vue-rate";
import "vue-rate/dist/vue-rate.css";
import VueAWN from "vue-awesome-notifications";

Vue.use(loading, {
  bg: "#41b883ad",
  icon: "refresh",
  size: 4,
  icon_color: "white",
});

Vue.prototype.$http = api;
api.defaults.timeout = 100000;

import VueTour from "vue-tour";

require("vue-tour/dist/vue-tour.css");

import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);

Vue.use(VueTour);
import "vue-awesome-notifications/dist/styles/style.css";

Vue.use(VueAWN);
Vue.use(SequentialEntrance);

import FloatingVue from "floating-vue";

Vue.use(FloatingVue);
import "floating-vue/dist/style.css";

//axios.defaults.baseURL = 'http://10.196.200.169/api';
///axios.defaults.baseURL = 'http://localhost/api';
//axios.defaults.withCredentials = true;
//axios.defaults.baseURL = 'http://10.0.80.152/api';
//axios.defaults.baseURL = 'https://api-segreteria.unigre.it/api';
//axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
///axios.defaults.headers.common['ApiKey'] = '771686f0-359d-488c-a783-b47921558f8f';
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

Vue.config.productionTip = false;
Vue.use(VueConfirmDialog);
Vue.component("vue-confirm-dialog", VueConfirmDialog.default);
Vue.use(rate);
Vue.use(VueToasted);
Vue.use(VTooltip);
Vue.use(vuetify);

import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);
new Vue({
  router,
  store,
  vuetify,
  i18n,
  loading,
  render: (h) => h(App),
}).$mount("#app");
